import { fetchApi } from '@/config/axiosSetting.ts';
import { VersionNotificationResponse } from './versionNotificationQuery.type';

export const versionNotificationFunction =
  (): Promise<VersionNotificationResponse> => {
    return fetchApi.get(`/splash/`);
  };
